import React from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TextLink } from '@frontend/design-system';

type ChipGroupProps<T> = {
  items: T[];
  maxVisible?: number;
  renderChip: (item: T, index: number) => React.ReactNode;
  onClick?: () => void;
};

export const ChipGroup = <T,>({ items, maxVisible = 1, renderChip, onClick }: ChipGroupProps<T>) => {
  const visibleItems = items.slice(0, maxVisible);
  const hiddenCount = items.slice(maxVisible).length;

  return (
    <div css={styles.wrapper}>
      {visibleItems.map(renderChip)}
      {hiddenCount > 0 && (
        <TextLink css={styles.hiddenText} onClick={onClick}>
          +{hiddenCount}
        </TextLink>
      )}
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    gap: ${theme.spacing(1)};
    align-items: center;
    flex-wrap: wrap;
  `,
  hiddenText: css`
    text-decoration: none;
    :hover {
      text-decoration: none;
    }
    :focus {
      text-decoration: none;
    }
  `,
};
